import { IPoint } from '../../../../../../../../graphql/lenses/models/get-lenses.models';

export const getPackSizes = (points: IPoint[] = []): number[] => {
  return points?.reduce((initialArray: number[], { packSize }) => {
    return [...initialArray, packSize];
  }, []);
};
